define('ctrl/member/member-reset-password',['require','ns','ctrl/base'],function (require) {
	'use strict';

	var ns = require('ns');

	var BaseController = require('ctrl/base');

	var _selector = {
		row_field: '.row-field',
		row_field_input: '.row-field-input',
		btn_reset: '#btnReset',
        form_password: '#password_form',
        field_password: '#password',
        field_password2: '#password2',
		required: '.js-required',
		message: '.message',
		error: '.error'
	};
    
    var $selector = {};

	var required_fields = [];

	var MemberResetPasswordController = BaseController.extend({

		init: function () {

			BaseController.prototype.init.call(this);

			$selector = ns.utils.generateSelector(_selector);
			
            this.getRequiredFields();
            
			this._registerEvent();
		},
        
        getUriSegment: function (i) {
            var segment =  window.location.pathname.substring(1).split('/');
            return segment[i];
        },
        
        _registerEvent: function () {
			
			var that = this;

			_.each(required_fields, function(required_field) {
				that.checkRequiredField(required_field);
			});
            
            $(_selector.btn_reset).click(function() {
                

				if (that.checkIsValidForm()) {
					$(_selector.form_password).submit();
				}
			});
		},
        
        getRequiredFields: function() {

			$(_selector.required).each(function() {
			
				var tag_name = $(this).prop('tagName');

				if (tag_name !== 'DIV') {

					required_fields.push({
						tag: tag_name,
						name: $(this).attr('name'),
						is_valid: false
					}); 					
				}
			});
		},

		checkRequiredField: function(required_field) {

			var that = this;

			var element = '[name="' + required_field.name + '"]';

			$(document).on('blur', element, function() {

				var is_not_empty = false;
                                var is_valid = false;

				is_not_empty = !_.isEmpty($(this).val());

				if (is_not_empty) {

					that.removeMessage($(this));
                                        if(that.checkIsValidPassword($(this))) {
                                            is_valid = true;
                                            that.checkIsMatchPassword();
                                        } else {
                                            var _localeCode = that.getUriSegment(0);
                                            that.showErrorMessage($(this), ns.resources[_localeCode].passwordInvalid);
                                        }
                    

				} else {
                    
                    var _localeCode = that.getUriSegment(0);

					that.showErrorMessage($(this), ns.resources[_localeCode].fieldIsRequired);
				}

				required_field.is_valid = (is_not_empty && is_valid);
			});
		},

		checkIsValidForm: function() {
            
            if (!this.checkIsMatchPassword()) {
                return false;
            }
            

			_.each(required_fields, function(required_field) {

				var element = '[name="' + required_field.name + '"]';

				$(element).blur();
			});

			var has_invalid_field = _.find(required_fields, function(required_field) {

				return required_field.is_valid === false;
			});

			return _.isUndefined(has_invalid_field);
		},
        
        checkIsMatchPassword: function() {
            
            if ($(_selector.field_password).val() !== '' && $(_selector.field_password2).val() !== '') {

                if ($(_selector.field_password).val() !== $(_selector.field_password2).val()) {
                    
                    var _localeCode = this.getUriSegment(0);
                    
                    this.showErrorMessage($(_selector.field_password2), ns.resources[_localeCode].passwordMismatch);
                    
                    return false;
                }
            }
            return true;
        },
        
        checkIsValidPassword: function (pw_obj) {
            var val = pw_obj.val();
            if (val.length >= 8 && (/[a-zA-Z]/.test(val) && /[0-9]/.test(val))) {
                return true;
            } else {
                
                return false;
            }
        },
        
        showErrorMessage: function(el_field, msg) {

			var el_row_field = el_field.parents(_selector.row_field)
				, el_row_field_input = el_row_field.find(_selector.row_field_input);

			if (el_row_field_input.parent().find(_selector.message).length > 0) {

				this.removeMessage(el_field);
			}

			var message = $('<span/>', {
				'class': _selector.message.substring(1),
				'text': msg
			});

			el_row_field_input.parent().append(message);

			el_row_field.addClass(_selector.error.substring(1));
		},

		removeMessage: function(el_field) {

			var el_row_field = el_field.parents(_selector.row_field)
				, el_row_field_input = el_row_field.find(_selector.row_field_input);

			el_row_field_input.parent().find(_selector.message).remove();

			el_row_field.removeClass(_selector.error.substring(1));
		}
	});

	return MemberResetPasswordController;
});
